import mixins from 'synergycms_core/src/less/mixins';

export default {
  radioButtonContainer: {
    position: 'relative',
    display: 'inline-block',
    paddingLeft: '29px',
    paddingRight: '20px',
    verticalAlign: 'middle',
    '&:lang(ar)':{
      paddingRight:'0',
    },
    '&:last-of-type': {
      paddingRight: '0',
      '&:lang(ar)':{
        paddingRight:'29px'
      }
    },
    '&:before': {
      content: "''",
      position: 'absolute',
      left: '0',
      top: '0',
      width: '16px',
      height: '16px',
      border: '1px solid #d8d8d8',
      ...mixins.mixinBorderRadius('50%'),
      ...mixins.boxShadow('0 0 7px -2px rgba(0,0,0,0.5)')
    },
    '& input': {
      position: 'fixed',
      top: '0',
      left: '-999px',
      width: '0',
      height: '0',
      ...mixins.opacity('0'),
      '&:checked ~ label:before': {
        backgroundColor: data => data.mainColor
      },
      '&:lang(ar)':{
        left:'auto',
        right:'-999px'
      }
    },
    '& label': {
      '&:before': {
        content: "' '",
        position: 'absolute',
        left: '4px',
        top: '4px',
        width: '10px',
        height: '10px',
        color: 'transparent',
        ...mixins.transition(),
        borderRadius: '50%'
      },
      '&:lang(ar)':{
        '&:before':{
          left: 'auto',
          right: '4px',
        }
      }
    },
    '&:lang(ar)':{
      paddingRight: '29px',
      paddingLeft: '20px',
      '&:before':{
        left: 'auto',
        right: '0',
      }
    }
  }
};
